export default __webpack_public_path__ + "static/media/allSampleFile.8d2f2de6.zip";